// ============================================
// Axios 请求封装
// ============================================

import axios from 'axios'
import { Message } from 'element-ui'
import { getToken, clearAuth } from './auth'
import router from '../router'
import { API_BASE_URL } from '../api/config'

const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    const token = getToken()
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    if (!res.success) {
      Message.error(res.message || '请求失败')
      return Promise.reject(new Error(res.message || '请求失败'))
    }
    return res
  },
  error => {
    console.error('响应错误:', error)
    if (error.response) {
      const { status, data, config } = error.response
      switch (status) {
        case 401:
          // 登录接口报 401，通常是账号密码错误，不需要清除 Token 和跳转
          if (config.url.includes('/auth/login')) {
            Message.error(data?.message || '账号或密码错误')
          } else {
            Message.error('登录已过期，请重新登录')
            clearAuth()
            router.push('/login')
          }
          break
        case 403:
          Message.error('无操作权限')
          break
        case 404:
          Message.error('请求的资源不存在')
          break
        default:
          Message.error(data?.message || '服务器错误')
      }
    } else {
      Message.error('网络连接失败')
    }
    return Promise.reject(error)
  }
)

export default service
